import {Table, Form, Space, Radio, Badge, Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import ExpenseCheck from './ExpenseCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './expense.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import ExpenseEditReportEdit from './ExpenseEditReportEdit';
import ExpenseEdit from './ExpenseEdit';
function ExpenseListSubmitted(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "fy_state": '',     
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => ((item.fy_state === '2' || item.fy_state === '3' || item.fy_state === '4' || item.fy_state === '5' || item.fy_state === '6') && item.fy_uid === props.yh_id) && item.fy_uid === props.yh_id);      
            if(query.fy_state){
                if(query.fy_state === '5'){
                  arr = arr.filter((item) => item.fy_state === '5' || item.fy_state === '6');
                }else{
                  arr = arr.filter((item) => item.fy_state === query.fy_state);
                }
              }      
              arr = arr.map((item) => ({
                  ...item,
                  key: item.key || item.fy_id
              }));
              const unread = arr.filter(item => item.fy_state === '5');
              const read = arr.filter(item => item.fy_state === '2' || item.fy_state === '3' || item.fy_state === '4' || item.fy_state === '6');
              read.sort((a, b) => new Date(b.fy_state_time) - new Date(a.fy_state_time));
              const sortedArr = [...unread, ...read];
              setList(sortedArr);
        }
    }, [props.list, query.fy_state, props.yh_id])
    
    const columns = [    
        {
            title: '费用客户',
            dataIndex: 'fy_kh_name',
            width: '12%',
            key: 'fy_kh_name',         
            render: (text, record) =>{
                if(record.fy_state === '4'){
                    if(record.fy_bzd_id){
                        return <ExpenseEditReportEdit
                            fy_id={record.key} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            fy_bzd_id={record.fy_bzd_id}
                            fy_bzd_name={record.fy_bzd_name}
                            fy_kh_id={record.fy_kh_id}
                            fy_kh_name={record.fy_kh_name}
                            fy_state={record.fy_state}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                        />
                    }else{
                        return <ExpenseEdit
                            fy_id={record.key} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            fy_bzd_id={record.fy_bzd_id}
                            fy_bzd_name={record.fy_bzd_name}
                            fy_kh_id={record.fy_kh_id}
                            fy_kh_name={record.fy_kh_name}
                            fy_state={record.fy_state}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                        />
                    }
                   
                }else{
                    return <ExpenseCheck
                                type='button'
                                fy_id={record.key} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                fy_bzd_id={record.fy_bzd_id}
                                fy_price={record.fy_price}
                                fy_content={record.fy_content}
                                fy_date={record.fy_date}
                                fy_date_end={record.fy_date_end}
                                fy_bzd_name={record.fy_bzd_name}
                                fy_bzd_danhao={record.fy_bzd_danhao}
                                fy_type_id={record.fy_type_id}
                                fy_type_name={record.fy_type_name}
                                fy_kh_id={record.fy_kh_id}
                                fy_kh_name={record.fy_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                fy_num={record.fy_num}
                                fy_amount={record.fy_amount}
                                fy_state={record.fy_state}
                                fy_bm_id={record.fy_bm_id}
                                fy_bm_name={record.fy_bm_name}
                                fy_khyhzh_id={record.fy_khyhzh_id}
                                fy_khyhzh_name={record.fy_khyhzh_name}
                                fy_image_name={record.fy_image_name}
                                fy_image_file={record.fy_image_file}
                                fy_ctime={record.fy_ctime}
                                fy_uid={record.fy_uid}
                                listType='submitted'
                            />
                }       
            }
        },
        {
            title: '费用金额',
            dataIndex: 'fy_amount',
            width: '10%',
            key: 'fy_amount',   
            render: (text, record) => <span style={{color:'#3366cc'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'fy_content',
            key:'fy_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"fy_bzd_danhao",
            key:'fy_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.fy_bzd_name} dsbzd_id={record.fy_bzd_id} dsbzd_danhao={record.fy_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },      
        {
            title: '审批时间',
            dataIndex: 'fy_state_time',
            width: '10%',
            key: 'fy_state_time',             
        },
        {
            title: '状态',
            dataIndex: 'fy_state',
            width: '5%',
            key: 'fy_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_expense_submitted'
                    form={form}
                    initialValues={{                        
                        fy_state: query.fy_state ? query.fy_state : '',                        
                    }}
                    onFinish={(values) => {
                        localStorage.setItem('jtg-caiwu_expenseList_fy_state', JSON.stringify(values.fy_state));  
                        setQuery(prev => ({ 
                            ...prev, 
                            fy_state: values.fy_state, 
                        }));
                    }}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    fy_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_loanList_fy_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge count={props.expenseRejectedNum} style={{zIndex:'9999'}}>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Badge count={props.expenseEndNeedReadNum} style={{zIndex:'9999'}}>
                                <Radio value='5' >已结束</Radio>
                            </Badge>                            
                        </Radio.Group>        
                    </Form.Item>                    
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_expenseList_fy_state', JSON.stringify(''))
                                    setQuery({
                                        "fy_state": '',                                        
                                    })
                                    form.setFieldsValue({
                                        fy_content: null,
                                        fy_kh_id: null,
                                        fy_bzd_danhao: null,
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'#3366cc'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无费用单' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default ExpenseListSubmitted